import { Flex, LabeledData } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

export type AnswerStatusSummaryProps = {
  bankReusedQuestions: number;
  generatedQuestions: number;
  noResponseQuestions: number;
};

// Static counts only — the provenance Select above is what narrows the question list.
export const AnswerStatusSummary = ({
  bankReusedQuestions,
  generatedQuestions,
  noResponseQuestions,
}: AnswerStatusSummaryProps) => {
  return (
    <Flex gap={SPACING.X_LARGE} data-testid="ddq-answer-status-summary">
      <LabeledData
        variant="standard"
        flippedLabel
        label="Previously answered"
        value={String(bankReusedQuestions)}
        data-testid="ddq-answer-status-bank-reused"
      />
      <LabeledData
        variant="standard"
        flippedLabel
        label="Generated by JunieAI"
        value={String(generatedQuestions)}
        data-testid="ddq-answer-status-generated"
      />
      <LabeledData
        variant="standard"
        flippedLabel
        label="No response"
        value={String(noResponseQuestions)}
        data-testid="ddq-answer-status-no-response"
      />
    </Flex>
  );
};
